<template>
	<svg
		width="16"
		height="18"
		viewBox="0 0 16 18"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="16" height="3" rx="1.5" />
		<rect y="15" width="16" height="3" rx="1.5" />
		<rect y="5" width="16" height="3" rx="1.5" />
		<rect y="10" width="16" height="3" rx="1.5" />
	</svg>
</template>

<script>
export default {
	name: "List",
};
</script>
